import type { RuleSet } from 'styled-components'
import { css, styled } from 'styled-components'
import { tk } from '../../utils/styling/get-token'

import { Typography } from '../Typography'
import { wrapTextChildrenWithTypography } from '../Typography/wrap-text-children-with-typography'

export type CollectionLabelType =
  | 'default'
  | 'boutique'
  | 'cycling'
  | 'excellent'
  | 'famfun'
  | 'primavera'
  | 'secrets'
  | 'selections'
  | 'villages'
  | 'xperience'
  | 'atlantis'
  | 'totally'
export type CollectionLabelVariant = 'default' | 'corner'

interface CollectionLabelProps {
  $type?: CollectionLabelType
  $variant?: CollectionLabelVariant
}

const CollectionLabel = styled.div.attrs<CollectionLabelProps>(({ children }) => ({
  children: wrapTextChildrenWithTypography(children),
}))`
  align-items: center;
  display: inline-flex;
  justify-content: center;

  & > * ~ * {
    margin-left: ${tk('spacing_2xs')};
  }

  ${({ $type }) => modType($type)}

  padding: ${tk('spacing_2xs')} ${tk('spacing_xs')};

  ${Typography} {
    ${Typography.modVariant('body-sm-bold')}
  }

  ${({ $variant }) => modVariant($variant)}
`

CollectionLabel.displayName = 'CollectionLabel'

function modVariant(variantName: CollectionLabelVariant = 'default'): RuleSet<object> {
  return ({
    corner: css`
      border-radius: 0 0 ${tk('radius_large')};
    `,
    default: css`
      border-radius: ${tk('radius_medium')};
    `,
  })[variantName]
}

function modType(typeName: CollectionLabelType = 'default'): RuleSet<object> {
  return ({
    boutique: css`
      background-color: ${tk('color_collection_boutique')};
      color: ${tk('color_semantic_text_on_color')};
    `,
    cycling: css`
      background-color: ${tk('color_collection_cycling')};
      color: ${tk('color_semantic_text_on_color')};
    `,
    excellent: css`
      background-color: ${tk('color_collection_excellent')};
      color: ${tk('color_semantic_text_on_color')};
    `,
    famfun: css`
      background-color: ${tk('color_collection_fam_fun')};
      color: ${tk('color_semantic_text_on_color')};
    `,
    primavera: css`
      background-color: ${tk('color_collection_primavera')};
      color: ${tk('color_semantic_text_on_color')};
    `,
    secrets: css`
      background-color: ${tk('color_collection_secrets')};
      color: ${tk('color_semantic_text_on_color')};
    `,
    selections: css`
      background-color: ${tk('color_collection_selections')};
      color: ${tk('color_semantic_text_on_color')};
    `,
    villages: css`
      background-color: ${tk('color_collection_villages')};
      color: ${tk('color_semantic_text_on_color')};
    `,
    xperience: css`
      background-color: ${tk('color_collection_xperience')};
      color: ${tk('color_semantic_text_on_color')};
    `,
    atlantis: css`
      background-color: ${tk('color_collection_atlantis')};
      color: ${tk('color_semantic_text_on_color')};
    `,
    totally: css`
      background-color: ${tk('color_collection_totally')};
      color: ${tk('color_semantic_text_on_color')};
    `,
    default: css`
      background-color: ${tk('color_semantic_bg_primary')};
      color: ${tk('color_semantic_text_on_color')};
    `,
  })[typeName]
}

/**
 * @deprecated Discuss with Design Team if another component in `@sunwebgroup/ui-components/uds` is needed instead.
 */
export default CollectionLabel
